import React from 'react';
import { ToastContainer } from 'react-toastify';

import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-toastify/dist/ReactToastify.css';
// Must come after the library stylesheet — it overrides it. See the file header.
import './styles/toastGlass.css';
import { AuthProvider } from 'contexts/AuthContext';
import { BrandProvider } from 'contexts/BrandContext';
import { WhiteLabelProvider } from 'contexts/WhiteLabelContext';
import BrandThemeProvider from 'contexts/BrandThemeProvider';
import { ColorModeProvider } from 'contexts/ColorModeContext';
import Main from './pages';

export default function App() {
  return (
    // The theme provider sits INSIDE BrandProvider and ColorModeProvider: it
    // needs to know which brand is selected and which mode is on before it can
    // build a palette, and context only flows downwards.
    <AuthProvider>
      <WhiteLabelProvider>
      <BrandProvider>
        <ColorModeProvider>
          <BrandThemeProvider>
            <ToastContainer
              position='top-right'
              autoClose={4000}
              hideProgressBar={false}
              // Left on 'light' deliberately: this prop only picks which of the
              // library's own classes it writes, and toastGlass.css overrides
              // the surface in both modes anyway — keyed off the data attribute
              // the colour-mode provider puts on <html>, which the library
              // cannot see.
              theme='light'
              // Toasts are glass panes floating over the page — let them overlap
              // the way real panes would rather than snapping to a hard column.
              newestOnTop
            />
            <Main />
          </BrandThemeProvider>
        </ColorModeProvider>
      </BrandProvider>
      </WhiteLabelProvider>
    </AuthProvider>
  );
}
